document.addEventListener('DOMContentLoaded', function() {
    // --- State Management for Filters ---
    const priceFilterState = new Map();
    const priceFilterDebugEnabled = (() => {
        try {
            const currentUrl = new URL(window.location.href);

            if (currentUrl.searchParams.get('priceFilterDebug') === '1') {
                window.localStorage.setItem('priceFilterDebug', '1');
                return true;
            }

            return window.localStorage.getItem('priceFilterDebug') === '1';
        } catch (_error) {
            return false;
        }
    })();

    const debugPriceFilter = (label, payload) => {
        if (!priceFilterDebugEnabled) {
            return;
        }
    };

    const parsePriceValue = (value, fallback = 0) => {
        if (value === null || typeof value === 'undefined') {
            return fallback;
        }

        const rawValue = String(value).trim();

        if (!rawValue.length) {
            return fallback;
        }

        let normalizedValue = rawValue.replace(/\s+/g, '').replace(/[^\d,.-]/g, '');

        if (!normalizedValue.length) {
            return fallback;
        }

        const lastDot = normalizedValue.lastIndexOf('.');
        const lastComma = normalizedValue.lastIndexOf(',');

        if (lastDot !== -1 && lastComma !== -1) {
            const decimalSeparator = lastDot > lastComma ? '.' : ',';
            const thousandsSeparator = decimalSeparator === '.' ? ',' : '.';

            normalizedValue = normalizedValue.split(thousandsSeparator).join('');

            if (decimalSeparator === ',') {
                normalizedValue = normalizedValue.replace(',', '.');
            }
        } else if (lastComma !== -1) {
            normalizedValue = normalizedValue.replace(',', '.');
        }

        const parsedValue = Number.parseFloat(normalizedValue);

        if (Number.isFinite(parsedValue)) {
            return parsedValue;
        }

        const digitsOnlyValue = normalizedValue.replace(/[^\d-]/g, '');

        if (!digitsOnlyValue.length) {
            return fallback;
        }

        return Number.parseInt(digitsOnlyValue, 10);
    };

    const formatPriceValue = (value) => {
        if (!Number.isFinite(value)) {
            return '';
        }

        return String(Math.round(value));
    };

    const clampPriceValue = (value, min, max) => {
        return Math.min(Math.max(value, min), max);
    };

    const getPriceFilterStorageKey = (control) => {
        return [
            'priceFilterRange',
            window.location.pathname,
            control.dataset.minPrice,
            control.dataset.maxPrice
        ].join(':');
    };

    const readStoredPriceValues = (control, absoluteMin, absoluteMax) => {
        const storedValues = priceFilterState.get(getPriceFilterStorageKey(control));

        if (!Array.isArray(storedValues) || storedValues.length !== 2) {
            return null;
        }

        const storedMin = clampPriceValue(parsePriceValue(storedValues[0], absoluteMin), absoluteMin, absoluteMax);
        const storedMax = clampPriceValue(parsePriceValue(storedValues[1], absoluteMax), absoluteMin, absoluteMax);

        return storedMin <= storedMax ? [storedMin, storedMax] : [storedMax, storedMin];
    };

    const writeStoredPriceValues = (control, values) => {
        priceFilterState.set(getPriceFilterStorageKey(control), values);
    };

    const triggerInputChange = (input) => {
        input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const initPriceFilters = () => {
        document.querySelectorAll('.price_filter__controls').forEach((control) => {
            if (control.dataset.sliderInitialized === 'true') {
                return;
            }

            const minInput = control.querySelector('input[name="price_filter_values[min]"]');
            const maxInput = control.querySelector('input[name="price_filter_values[max]"]');
            const sliderElement = control.querySelector('.price_filter__slider');
            const sliderRange = control.querySelector('.price_filter__slider-range');
            const minHandle = control.querySelector('.price_filter__slider-handle--min');
            const maxHandle = control.querySelector('.price_filter__slider-handle--max');

            if (!minInput || !maxInput || !sliderElement || !sliderRange || !minHandle || !maxHandle) {
                return;
            }

            const rawAbsoluteMin = parsePriceValue(control.dataset.minPrice, 0);
            const rawAbsoluteMax = parsePriceValue(control.dataset.maxPrice, rawAbsoluteMin);
            const absoluteMin = Math.ceil(rawAbsoluteMin);
            const absoluteMax = Math.max(absoluteMin, Math.floor(rawAbsoluteMax));
            const hasDecimalHint = /[.,]\d{1,2}$/.test(String(control.dataset.minPrice))
                || /[.,]\d{1,2}$/.test(String(control.dataset.maxPrice));

            debugPriceFilter('init', {
                dataset: {
                    minPrice: control.dataset.minPrice,
                    maxPrice: control.dataset.maxPrice
                },
                inputs: {
                    min: minInput.value,
                    max: maxInput.value
                },
                placeholders: {
                    min: minInput.placeholder,
                    max: maxInput.placeholder
                },
                parsed: {
                    rawAbsoluteMin,
                    rawAbsoluteMax,
                    absoluteMin,
                    absoluteMax
                }
            });

            if (absoluteMax <= absoluteMin) {
                debugPriceFilter('init-skipped-invalid-range', {
                    absoluteMin,
                    absoluteMax
                });
                return;
            }

            const readCurrentValues = () => {
                let currentMin = parsePriceValue(minInput.value, absoluteMin);
                let currentMax = parsePriceValue(maxInput.value, absoluteMax);
                const storedValues = readStoredPriceValues(control, absoluteMin, absoluteMax);
                const inputMinHasValue = minInput.value.trim().length > 0;
                const inputMaxHasValue = maxInput.value.trim().length > 0;

                if (hasDecimalHint && inputMinHasValue && currentMin > absoluteMax && currentMin / 100 <= absoluteMax) {
                    currentMin = currentMin / 100;
                }

                if (hasDecimalHint && inputMaxHasValue && currentMax > absoluteMax && currentMax / 100 <= absoluteMax) {
                    currentMax = currentMax / 100;
                }

                currentMin = inputMinHasValue ? Math.ceil(currentMin) : absoluteMin;
                currentMax = inputMaxHasValue ? Math.floor(currentMax) : absoluteMax;

                const brokenMaxState = inputMinHasValue
                    && inputMaxHasValue
                    && currentMin === currentMax
                    && currentMin === absoluteMin
                    && absoluteMin !== absoluteMax;

                debugPriceFilter('read-current-values-before-fix', {
                    rawInputs: {
                        min: minInput.value,
                        max: maxInput.value
                    },
                    parsedInputs: {
                        min: currentMin,
                        max: currentMax
                    },
                    storedValues,
                    brokenMaxState
                });

                if (brokenMaxState) {
                    if (storedValues) {
                        [currentMin, currentMax] = storedValues;
                    } else {
                        currentMax = absoluteMax;
                    }

                    debugPriceFilter('read-current-values-broken-max-fixed', {
                        fixedValues: {
                            min: currentMin,
                            max: currentMax
                        },
                        usedStoredValues: Boolean(storedValues)
                    });
                }

                currentMin = clampPriceValue(currentMin, absoluteMin, absoluteMax);
                currentMax = clampPriceValue(currentMax, absoluteMin, absoluteMax);

                if (currentMin > currentMax) {
                    [currentMin, currentMax] = [currentMax, currentMin];
                }

                debugPriceFilter('read-current-values-final', {
                    values: {
                        min: currentMin,
                        max: currentMax
                    }
                });

                return [currentMin, currentMax];
            };

            const writeCurrentValues = (values) => {
                minInput.value = formatPriceValue(values[0]);
                maxInput.value = formatPriceValue(values[1]);
            };

            const sliderStep = 1;
            const sliderSpan = absoluteMax - absoluteMin;
            let currentValues = readCurrentValues();

            const valueToPercent = (value) => {
                if (!sliderSpan) {
                    return 0;
                }

                return ((value - absoluteMin) / sliderSpan) * 100;
            };

            const pointerToValue = (clientX) => {
                const sliderBounds = sliderElement.getBoundingClientRect();

                if (!sliderBounds.width) {
                    return currentValues[0];
                }

                const relativePosition = clampPriceValue(clientX - sliderBounds.left, 0, sliderBounds.width);
                const rawValue = absoluteMin + (relativePosition / sliderBounds.width) * sliderSpan;
                const steppedValue = absoluteMin + Math.round((rawValue - absoluteMin) / sliderStep) * sliderStep;

                return clampPriceValue(steppedValue, absoluteMin, absoluteMax);
            };

            const renderSlider = () => {
                const [currentMin, currentMax] = currentValues;
                const minPercent = valueToPercent(currentMin);
                const maxPercent = valueToPercent(currentMax);

                minHandle.style.left = minPercent + '%';
                maxHandle.style.left = maxPercent + '%';
                sliderRange.style.left = minPercent + '%';
                sliderRange.style.width = (maxPercent - minPercent) + '%';
            };

            const setSliderValues = (values, source = 'unknown') => {
                currentValues = values;
                writeCurrentValues(values);
                writeStoredPriceValues(control, values);
                renderSlider();

                debugPriceFilter('set-slider-values', {
                    source,
                    values: {
                        min: values[0],
                        max: values[1]
                    },
                    inputsAfterWrite: {
                        min: minInput.value,
                        max: maxInput.value
                    }
                });
            };

            const updateValueFromPointer = (clientX, handleType) => {
                const pointerValue = pointerToValue(clientX);
                let [currentMin, currentMax] = currentValues;

                if (handleType === 'min') {
                    currentMin = Math.min(pointerValue, currentMax);
                } else {
                    currentMax = Math.max(pointerValue, currentMin);
                }

                setSliderValues([currentMin, currentMax], 'pointer-' + handleType);
            };

            const startDrag = (event, handleType) => {
                event.preventDefault();
                sliderElement.classList.add('price_filter__slider--dragging');
                updateValueFromPointer(event.clientX, handleType);

                const handlePointerMove = (moveEvent) => {
                    updateValueFromPointer(moveEvent.clientX, handleType);
                };

                const handlePointerUp = () => {
                    sliderElement.classList.remove('price_filter__slider--dragging');
                    document.removeEventListener('pointermove', handlePointerMove);
                    document.removeEventListener('pointerup', handlePointerUp);
                    document.removeEventListener('pointercancel', handlePointerUp);
                    triggerInputChange(minInput);
                };

                document.addEventListener('pointermove', handlePointerMove);
                document.addEventListener('pointerup', handlePointerUp);
                document.addEventListener('pointercancel', handlePointerUp);
            };

            const moveClosestHandle = (event) => {
                if (event.target === minHandle || event.target === maxHandle) {
                    return;
                }

                const pointerValue = pointerToValue(event.clientX);
                const distanceToMin = Math.abs(pointerValue - currentValues[0]);
                const distanceToMax = Math.abs(pointerValue - currentValues[1]);
                const closestHandle = distanceToMin <= distanceToMax ? 'min' : 'max';

                startDrag(event, closestHandle);
            };

            setSliderValues(currentValues, 'init');

            minHandle.addEventListener('pointerdown', (event) => {
                startDrag(event, 'min');
            });

            maxHandle.addEventListener('pointerdown', (event) => {
                startDrag(event, 'max');
            });

            sliderElement.addEventListener('pointerdown', moveClosestHandle);

            const syncSliderFromInputs = () => {
                setSliderValues(readCurrentValues(), 'input-change');
            };

            minInput.addEventListener('change', function() {
                debugPriceFilter('min-input-change', {
                    value: minInput.value,
                    otherValue: maxInput.value
                });
                syncSliderFromInputs();
            });

            maxInput.addEventListener('change', function() {
                debugPriceFilter('max-input-change', {
                    value: maxInput.value,
                    otherValue: minInput.value
                });
                syncSliderFromInputs();
            });

            minInput.addEventListener('input', function() {
                currentValues = readCurrentValues();
                renderSlider();

                debugPriceFilter('min-input-live', {
                    value: minInput.value,
                    currentValues
                });
            });

            maxInput.addEventListener('input', function() {
                currentValues = readCurrentValues();
                renderSlider();

                debugPriceFilter('max-input-live', {
                    value: maxInput.value,
                    currentValues
                });
            });

            control.dataset.sliderInitialized = 'true';
        });
    };

    const getExpandedFilters = () => {
        try {
            return JSON.parse(sessionStorage.getItem('expandedFilters')) || [];
        } catch (e) {
            return [];
        }
    };

    const setExpandedFilters = (filters) => {
        sessionStorage.setItem('expandedFilters', JSON.stringify(filters));
    };

    const updateFilterState = (filterId, isExpanded) => {
        if (!filterId) return;
        const filters = getExpandedFilters();
        const index = filters.indexOf(filterId);
        
        if (isExpanded) {
            if (index === -1) filters.push(filterId);
        } else {
            if (index !== -1) filters.splice(index, 1);
        }
        setExpandedFilters(filters);
    };

    const restoreFilterState = () => {
        const expandedFilters = getExpandedFilters();
        if (expandedFilters.length === 0) return;

        expandedFilters.forEach(filterId => {
            const button = document.querySelector(`.filter__toggle-btn[data-target="${filterId}"]`);
            if (!button) return;

            const filterList = button.previousElementSibling;
            if (!filterList) return;

            const hiddenItems = filterList.querySelectorAll('.filter__item--hidden');
            const moreText = button.querySelector('.filter__toggle-text--more');
            const lessText = button.querySelector('.filter__toggle-text--less');

            if (hiddenItems.length === 0) return;

            // Only expand if not already expanded
            if (!hiddenItems[0].classList.contains('filter__item--visible')) {
                hiddenItems.forEach(item => item.classList.add('filter__item--visible'));
                if (moreText) moreText.style.display = 'none';
                if (lessText) lessText.style.display = '';
            }
        });
    };

    // Initial restore
    restoreFilterState();
    initPriceFilters();

    // Watch for DOM changes (AJAX) to restore state after content update
    const observer = new MutationObserver((mutations) => {
        const hasAddedNodes = mutations.some(mutation => mutation.addedNodes.length > 0);
        if (hasAddedNodes) {
            restoreFilterState();
            initPriceFilters();
        }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', function(e) {
        const button = e.target.closest('.filter__toggle-btn');
        if (!button) return;

        const filterId = button.getAttribute('data-target');
        const filterList = button.previousElementSibling;
        
        if (!filterList) return;
        
        const hiddenItems = filterList.querySelectorAll('.filter__item--hidden');
        const moreText = button.querySelector('.filter__toggle-text--more');
        const lessText = button.querySelector('.filter__toggle-text--less');
        
        if (hiddenItems.length === 0) return;
        
        const isExpanded = hiddenItems[0].classList.contains('filter__item--visible');
        
        hiddenItems.forEach(item => {
            item.classList.toggle('filter__item--visible');
        });
        
        if (isExpanded) {
            if (moreText) moreText.style.display = '';
            if (lessText) lessText.style.display = 'none';
            updateFilterState(filterId, false);
        } else {
            if (moreText) moreText.style.display = 'none';
            if (lessText) lessText.style.display = '';
            updateFilterState(filterId, true);
        }
    });
    
    const filterPanelToggles = document.querySelectorAll('.filter-panel__toggle-btn');
    const filterPanelCloseWrapper = document.querySelector('.filter-panel__close-wrapper');
    const filterPanelClose = document.querySelector('.filter-panel__close');
    const filterPanel = document.querySelector('.filter-panel');

    const setFilterPanelState = (isOpen) => {
        if (filterPanel) {
            filterPanel.classList.toggle('filter-panel--active', isOpen);
        }

        if (filterPanelCloseWrapper) {
            filterPanelCloseWrapper.classList.toggle('active', isOpen);
        }

        document.body.classList.toggle('filter-visible', isOpen);
    };

    filterPanelToggles.forEach(button => {
        button.addEventListener('click', function() {
            const isOpen = filterPanel
                ? !filterPanel.classList.contains('filter-panel--active')
                : !document.body.classList.contains('filter-visible');

            setFilterPanelState(isOpen);
        });
    });

    if (filterPanelClose) {
        filterPanelClose.addEventListener('click', function() {
            setFilterPanelState(false);
        });
    }

    // Zavření filtru po stisku ESC
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            if (document.body.classList.contains('filter-visible')) {
                setFilterPanelState(false);
            }
        }
    });
});